import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

const Select = styled.div`
  width: 100%;
  position: relative;

  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus,
  select:-webkit-autofill:active {
    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';
    -webkit-transition-delay: 9999s;
  }
`;

const LabelWrapper = styled.div`
  padding: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-2']}
    ${theme.spacing['spacing-2']} ${theme.spacing['spacing-5']};
  display: flex;
`;

const SelectTag = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  width: 100%;
  height: 40px;
  background-color: ${theme.colors.neutral.bg.weak};
  border-radius: ${theme.borderRadius['border-radius-5']};
  padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-3']}
    ${theme.spacing['spacing-3']} ${theme.spacing['spacing-5']};
  box-shadow: inset 0 0 0 1px ${theme.colors['neutral'].border.regular};
  ${theme.textStyles['text-preset-9']};
  color: ${theme.colors['neutral'].text.strong};
  ${({ error }) =>
    error === true &&
    css`
      box-shadow: inset 0 0 0 1px ${theme.colors['danger'].border.regular};
    `}
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43MzY0IDkuMjYzNjNDMTcuMzg0OSA4LjkxMjE2IDE2LjgxNTEgOC45MTIxNiAxNi40NjM2IDkuMjYzNjNMMTIgMTMuNzI3Mkw3LjUzNjM5IDkuMjYzNjNDNy4xODQ5MiA4LjkxMjE2IDYuNjE1MDcgOC45MTIxNiA2LjI2MzYgOS4yNjM2M0M1LjkxMjEzIDkuNjE1MSA1LjkxMjEzIDEwLjE4NSA2LjI2MzYgMTAuNTM2NEwxMS4zNjM2IDE1LjYzNjRDMTEuNzE1MSAxNS45ODc5IDEyLjI4NSAxNS45ODc5IDEyLjYzNjQgMTUuNjM2NEwxNy43MzY0IDEwLjUzNjRDMTguMDg3OSAxMC4xODQ5IDE4LjA4NzkgOS42MTUxIDE3LjczNjQgOS4yNjM2M1oiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==');
  background-repeat: no-repeat;
  background-position-x: calc(100% - 10px);
  background-position-y: 50%;

  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 1px ${theme.colors['secondary-1'].border.regular};
  }

  outline: none;
  ${({ disabled }) =>
    disabled === true &&
    css`
      background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43MzY0IDkuMjYzNjNDMTcuMzg0OSA4LjkxMjE2IDE2LjgxNTEgOC45MTIxNiAxNi40NjM2IDkuMjYzNjNMMTIgMTMuNzI3Mkw3LjUzNjM5IDkuMjYzNjNDNy4xODQ5MiA4LjkxMjE2IDYuNjE1MDcgOC45MTIxNiA2LjI2MzYgOS4yNjM2M0M1LjkxMjEzIDkuNjE1MSA1LjkxMjEzIDEwLjE4NSA2LjI2MzYgMTAuNTM2NEwxMS4zNjM2IDE1LjYzNjRDMTEuNzE1MSAxNS45ODc5IDEyLjI4NSAxNS45ODc5IDEyLjYzNjQgMTUuNjM2NEwxNy43MzY0IDEwLjUzNjRDMTguMDg3OSAxMC4xODQ5IDE4LjA4NzkgOS42MTUxIDE3LjczNjQgOS4yNjM2M1oiIGZpbGw9IiM2NDcxODAiLz4KPC9zdmc+Cg==');
      color: ${theme.colors['neutral'].text.regular};
      background-color: ${theme.colors['neutral'].bg.regular};
      box-shadow: inset 0 0 0 1px ${theme.colors['neutral'].border.regular};
      background-color: ${theme.colors['neutral'].bg.regular};
      &:hover,
      &:focus {
        box-shadow: inset 0 0 0 1px ${theme.colors['neutral'].border.regular};
      }
    `}

  option {
    ${theme.textStyles['text-preset-9']};
  }
`;

const HelpText = styled.div`
  padding: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-2']}
    ${theme.spacing['spacing-2']} ${theme.spacing['spacing-5']};
  display: flex;
  align-items: center;
  position: absolute;
  ${({ status }) =>
    status === true &&
    css`
      > * {
        &:first-child {
          margin-right: ${theme.spacing['spacing-2']} !important;
        }
      }
    `}
`;

export { SelectTag, LabelWrapper, HelpText, Select };
